// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2_J_G","errors":"Errors_errors__1Vd78"};